import React, { useEffect, useState } from 'react';
import axios from 'axios';
import 'tailwind-scrollbar'; // Import tailwind-scrollbar if needed
import APIEndPoints from '../../../middleware/APIEndPoints';

const WorkWithMeList = () => {
  const [workWithMeList, setWorkWithMeList] = useState([]);
  const [selectedEntry, setSelectedEntry] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);


  const baseUrl = APIEndPoints.workwithme.url

  useEffect(() => {
    // Fetch all WorkWithMe data
    const fetchWorkWithMe = async () => {
      try {
        const response = await axios.get(baseUrl); // Your API endpoint
        console.log(response.data); // Check the response structure

        if (response.data.success && Array.isArray(response.data.workEntries)) {
          setWorkWithMeList(response.data.workEntries); // Set the list from the workEntries array
        } else {
          console.error("Expected an array in workEntries but received:", typeof response.data.workEntries);
          setWorkWithMeList([]); // Ensure it's an empty array if not found
        }
      } catch (error) {
        console.error('Error fetching work with me data:', error);
        setWorkWithMeList([]); // Handle error by setting an empty array
      }
    };

    fetchWorkWithMe();
  }, []);

  const openModal = (entry) => {
    setSelectedEntry(entry);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedEntry(null);
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(`${baseUrl}/${id}`); // Your API endpoint for delete
      setWorkWithMeList((prevList) => prevList.filter((entry) => entry._id !== id)); // Update the list
    } catch (error) {
      console.error('Error deleting entry:', error);
    }
  };

  return (
    <div className="bg-[#1d0c39]  min-h-screen p-8 text-white">
      <h1 className="text-2xl font-bold mb-4">Work With Me Entries</h1>
      {workWithMeList.length === 0 ? (
        <p>No entries found.</p>
      ) : (
        <ul>
          {workWithMeList.map((entry) => (
            <li key={entry._id} className="bg-black/80 p-4 rounded-lg mb-4">
              <h2 className="text-xl font-semibold">{entry.companyName}</h2>
              <p>Company Address: {entry.companyAddress}</p>
              <p>Service: {entry.service.name}</p>

              <div className="flex mt-2 space-x-4">
                <button
                  onClick={() => openModal(entry)}
                  className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
                >
                  View Details
                </button>
                <button
                  onClick={() => handleDelete(entry._id)}
                  className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600"
                >
                  Delete
                </button>
              </div>
            </li>
          ))}
        </ul>
      )}

      {/* Inline Modal Implementation */}
      {isModalOpen && selectedEntry && (
        <div className="fixed inset-0 bg-gray-900 bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-black p-6 rounded-lg shadow-lg max-w-lg w-full relative">
            <button
              onClick={closeModal}
              className="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
            >
              ✕
            </button>
            <h2 className="text-2xl font-bold mb-4">{selectedEntry.companyName}</h2>
            <p><strong>Company Address:</strong> {selectedEntry.companyAddress}</p>
            <p><strong>First Name:</strong> {selectedEntry.firstName}</p>
            <p><strong>Last Name:</strong> {selectedEntry.lastName}</p>
            <p><strong>Email:</strong> {selectedEntry.email}</p>
            <p><strong>Phone:</strong> {selectedEntry.phone}</p>
            <p><strong>Country:</strong> {selectedEntry.country}</p>
            <p><strong>Service:</strong> {selectedEntry.service.name}</p>
            <p><strong>Message:</strong> {selectedEntry.message}</p>

            <button
              onClick={closeModal}
              className="mt-4 bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600"
            >
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default WorkWithMeList;
